import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { NumericalDayOfWeek } from "@whoosh/utilities/src/calendars";

import { useGetClubStartOfWeekNumberPatron_club$key } from "./__generated__/useGetClubStartOfWeekNumberPatron_club.graphql";

export const useGetClubStartOfWeekNumberPatron = (
  clubRef: useGetClubStartOfWeekNumberPatron_club$key | null
): NumericalDayOfWeek => {
  const club = useFragment(
    useGetClubStartOfWeekNumberPatronFragmentString,
    clubRef
  );
  const calendarStartDay = club?.calendarStartDay;
  const dayToNumberMap = { SUNDAY: 0, MONDAY: 1 };
  return dayToNumberMap[calendarStartDay || "MONDAY"] as NumericalDayOfWeek;
};

export const useGetClubStartOfWeekNumberPatronFragmentString = graphql`
  fragment useGetClubStartOfWeekNumberPatron_club on Club {
    calendarStartDay
  }
`;
